import React from "react";
import { useAuthentication } from "../../../../context/authentication";
import { DottedMenu } from "../../../../context/dropdownMenu/DropdownMenuProvider";
import { useLabels } from "../../../../context/labels";
import { Label } from "../../../../utils/types";

interface Props {
  disabled?: boolean;
  label: Label;
  toggleEditLabelForm: (label: Label) => void;
}

const LabelActionsButton: React.FC<Props> = ({
  disabled,
  label,
  toggleEditLabelForm
}) => {
  const { wrapActionWithAuth } = useAuthentication();
  const { removeLabel } = useLabels();

  return (
    <DottedMenu
      text="Open label actions"
      disabled={disabled}
      menuItems={[
        {
          text: "Edit label",
          onClick: wrapActionWithAuth(() => {
            toggleEditLabelForm(label);
          })
        },
        {
          text: "Remove label",
          onClick: wrapActionWithAuth(() => {
            removeLabel(label.uuid);
          })
        }
      ]}
    />
  );
};

export default LabelActionsButton;
